import React from 'react';
import Loadable from 'react-loadable';
import { parseLocale } from '@tesla/parse-locale';

// Containers
import MapContainer from './MapContainer';
import FilterContainer from './FilterContainer';
import SearchInputContainer from './SearchInputContainer';
import CardContainer from './CardContainer';
import NotifierContainer from './NotifierContainer';
import OverlayContainer from './OverlayContainer';

const locale = window.tesla && window.tesla.App ? window.tesla.App.locale : 'en_US';
const { country } = parseLocale(locale);
const isCN = country === 'CN';

// Load BMap Container and its resoruces only if CN market
const BMapContainers = Loadable({
  loader: () => (isCN ? import('./BMapContainers') : null),
  loading: () => <div />,
});

const App = () => (
  <div
    className={
      window.location.href.includes('platform=kiosk')
        ? 'kiosk findus-container'
        : 'findus-container'
    }
  >
    {isCN && <BMapContainers />}
    {!isCN && <MapContainer kiosk={window.location.href.includes('platform=kiosk')} />}
    {!isCN && <FilterContainer />}
    {!isCN && <SearchInputContainer />}
    {!isCN && <CardContainer />}
    {!isCN && <NotifierContainer isCN={isCN} country={country} />}
    {!isCN && <OverlayContainer />}
  </div>
);

export default App;
